import { api } from './requestGraphql.js';
import request from "@/api/request";
import {getCookie} from "@/helpers";

const updateSale = async ({lid, payin, payout, notes}) => {
    try {
        console.time(`updateSale`);

        const res = await api.post('', {
            query: `
                mutation {
                  updateSale(
                    lid: "${lid}",
                    payin: ${payin},
                    payout: ${payout},
                    notes: "${notes}"
                  ) {
                    success
                    message
                  }
                }
              `,
        });

        let response = res.data.data.updateSale;

        console.log(` *** Sale update response: ${JSON.stringify(response)}`);
        console.timeEnd(`updateSale`);
        return response;
    } catch (e) {
        console.log(e);
    }
};

const getSaleHistory = async (id) => {
    try {
        const result = await request.post(`/graphql`, {
                query: `
        {
          getHistory(
            id:${id}
            entity: "sales"
          ){
            id
            sflId
            user
            action
            dateAdded
            logs
            
          } 
        }
      `,
            },
            {
                headers: {
                    'Authorization': getCookie('accessToken'),
                    'Referrer-Police': 'strict-origin-when-cross-origin',
                    'Access-Control-Allow-Origin': '*',
                    'workspace': localStorage.getItem('workspace') || 'ac'
                }
            }
        )

        return result.data.data.getHistory;
    } catch (e) {
        console.log(e)
    }
}

export default {
    updateSale,
    getSaleHistory
};
